import { render, staticRenderFns } from "./property-results-card-list.vue?vue&type=template&id=56b5199f&scoped=true&"
import script from "./property-results-card-list.vue?vue&type=script&lang=ts&"
export * from "./property-results-card-list.vue?vue&type=script&lang=ts&"
import style0 from "./property-results-card-list.vue?vue&type=style&index=0&id=56b5199f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5199f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
